import { graphql, useStaticQuery } from 'gatsby';

export default function InsuranceMenuLinks() {
  const InsuranceMenu = useStaticQuery(graphql`
    query MyInsuranceQuery {
      allMenuLinkContentInsurance {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return InsuranceMenu;
}
